export default defineNuxtRouteMiddleware(async (to, _) => {
  const {
    $iproAuthenticated,
    $iproKeycloak,
    $iproUpdateToken,
    $iproTokenIsExpired,
  } = useNuxtApp()

  if (import.meta.server) {
    return
  }

  if (!$iproAuthenticated.value) {
    return initiateLogin()
  }
  else if ($iproTokenIsExpired()) {
    await $iproUpdateToken().catch((_) => {
      return initiateLogin()
    })
  }

  function initiateLogin() {
    return $iproKeycloak.login({
      redirectUri: to.fullPath ? window.location.origin + to.fullPath : window.location.href,
    })
  }
})
